



















































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component({})
export default class NeedDocument extends Vue {
	private recipientSameWithPublisher: boolean = false

	@Prop()
	private mediateForm!: any

	private afterAdd() {
		this.recipientSameWithPublisher = true
		this.setRecipient()
	}

	private onNeedChange(evt: any) {
		if (evt.target.value === '1') {
			this.afterAdd()
		}
	}

	private onRecipientSameChange(e: any) {
		this.recipientSameWithPublisher = e.target.checked
		this.setRecipient()
	}

	private setRecipient() {
		this.$nextTick(() => {
			if (this.recipientSameWithPublisher) {
				this.mediateForm.setFieldsValue({
					[`mailReceivor`]: this.$store.state.user.userInfo.name,
					[`mailReceivorPhone`]: this.$store.state.user.userInfo.mobile,
				})
			} else {
				this.mediateForm.setFieldsValue({
					[`mailReceivor`]: undefined,
					[`mailReceivorPhone`]: undefined,
				})
			}
		})
	}
}
